import React from 'react';

import styles from './styles.css';

export interface IFormLayoutProps {
  children: React.ReactElement | null;
}

export const FormLayout: React.FC<IFormLayoutProps> = ({ children }) => {
  return (
    <div className={styles['layout']} data-testid="form-layout">
      {children}
    </div>
  );
};

FormLayout.displayName = 'FormLayout';
